module.exports = __webpack_public_path__ + "static/img/202202.d93f6fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/202202.jpg
// module id = G6sP
// module chunks = 0